import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MonitorRoute from './components/monitor/MonitorRoute';
import InstructorPanel from './components/instructor/InstructorPanel';
import ReplayRoute from './components/replay/ReplayRoute';
import ErrorBoundary from './components/ErrorBoundary';
import DebugOverlay from './components/DebugOverlay';
import './styles/theme.css';

function App() {
  return (
    <>
      {/* future flags: opt in to v7 behaviour now — silences the Router's
          console.warn deprecation notices, which the crash-log overlay would
          otherwise surface as spurious ⚠ entries on every load. */}
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          {/* Each screen is wrapped so a transient render error self-heals instead
              of leaving a permanently black monitor. */}
          <Route path="/monitor" element={<ErrorBoundary><MonitorRoute /></ErrorBoundary>} />
          <Route path="/instructor" element={<ErrorBoundary><InstructorPanel /></ErrorBoundary>} />
          <Route path="/replay" element={<ErrorBoundary><ReplayRoute /></ErrorBoundary>} />
          <Route path="/" element={<Navigate to="/monitor" replace />} />
        </Routes>
      </Router>
      {/* Sits outside the route boundaries so the crash-log viewer survives even
          when a route itself is throwing. Hidden until ?debug=1, ⌘/Ctrl+Shift+D,
          or an error surfaces its badge. */}
      <DebugOverlay />
    </>
  );
}

export default App;
